import { NumberSpinner } from "@planningcenter/doxy-web"

export function Number({ customField }: { customField: any }) {
  const fieldName =
    customField.relationships.field_definition.data.attributes.name
  const { min, max } =
    customField.relationships.field_definition.data.attributes.config

  return (
    <div key={customField.id} className="mb-2">
      <label htmlFor={fieldName}>{fieldName}</label>
      <NumberSpinner
        min={min}
        max={max}
        name={fieldName}
        onChange={() => { }}
        value={0} // TODO: Will address this is next PR
      />
    </div>
  )
}
